<template>
  <div id="contenedor-detalle">
    <v-select
      v-model="vModel"
      v-bind="$attrs"
      v-on="$listeners"
      :items="items"
      item-text="total"
      item-value="id"
      chips
      hide-details
      class="my-input custom-label-color"
      color="#6A83B5"
      background-color="#F2F6FF"
      filled
      :rounded="!hasError"
      :outlined="hasError"
      :append-icon="$attrs.appendIcon"
      @update:error="errorChange"
      @blur="validateError">
      <template v-slot:label>
        <strong :class="hasError ? '' : 'custom-input-label-color'">
          {{ $attrs.label }}
        </strong>
      </template>
      <template
        v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          :color="data.item.color"
          dark>
          <v-avatar
            left>
            <span>
              {{ data.item.numero }}
            </span>
          </v-avatar>
          {{ data.item.total | currency }}
        </v-chip>
      </template>
      <template
        v-slot:item="data">
        <template
          v-if="data.item.header">
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.header }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <template
          v-else>
          <v-list-item-avatar>
            <v-avatar
              :color="data.item.color">
              <span class="white--text">
                {{ data.item.numero }}
              </span>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.total | currency }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ new Date(`${data.item.fecha} 00:00:0`).toLocaleDateString() }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'SolicitudDetalle',
  props: {
    value: {
      default() {
        return this.value || null;
      },
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
  methods: {
    validateError() {
      this.hasError = !this.value;
    },
    errorChange(event) {
      this.hasError = event;
    },
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
